<template>
    <b-overlay :show="busy">
        <div :class="alignment">
            <b-button v-if="queueId == 0" size='sm' variant="outline-secondary" @click.stop.prevent="addQueue()" class="mt-2">
                <b-icon-plus></b-icon-plus>
            </b-button>
            <b-button v-if="queueId != 0" variant="outline-secondary" size='sm' @click.stop.prevent="removeQueue()" class="mt-2">
                <b-icon-dash></b-icon-dash>
            </b-button>
        </div>
    </b-overlay>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

// Embedded due to init.
// var data = {
//   debug: false,
//  };

export default {
  name: "QueueButton",
  data() {
    return {
      debug: false,
      error: false,
      busy: false,
      classHash: null,
      studentHash: null,
      queueId: 0
    }
  },
  props: {
    c: {  // class hash object
      type: String,
      default: null
    },
    s: {  // student hash
      type: String,
      default: null
    },
    q: {  // classQueue.classQueueId
      type: [Number,String],
      default: '0'
    },
    alignment: {  // bootstrap alignment: text-left, text-right, text-center
      type: String,
      default: 'text-center'
    }
  },
  computed: {
   },
  methods: {
    addQueue() {
      this.busy = true
      service
        .saveQueue(this.classHash, this.studentHash)
        .then(
          (res => {
            console.log(`back from saveQueue`)
            if (this.debug) console.log(res)
            if (res.status) {
                this.queueId = res.queueId
            }
            else {
                console.log(`Error on return from saveQueue. ${res.status}`)
                this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
          // console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          console.log(e);
        })
    },
    removeQueue() {
      // console.log(`Removing seat: ${hash}`)
      this.busy = true
      service
        .removeQueue(this.classHash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              if (res.classObj.status) {
                this.queueId = 0
                this.$emit('remove-class', res.classObj.hash)
              }
            }
            else {
              this.error = true
              console.log(`Error from removeQueue: ${res.status}`)
              // this.errorMsg = "Error: Unable to remove class."
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = "Error trapped while removing class."
          console.log(e);
        })
    },
   },
  created() {
    // console.log(`Created: cid: ${this.cid}  q: ${this.q} `)
    this.classHash = this.c || null
    this.studentHash = this.s || null
    this.queueId = parseInt(this.q.toString()) || 0
    // console.log(`c: ${this.c} s: ${this.s} q: ${this.q}`)
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/QueueButton.vue